"use client";

import { c as _c } from "react/compiler-runtime";
import type { UrlObject } from "node:url";
import { HugeiconsIcon, type IconSvgElement } from "@hugeicons/react";
import type { Route } from "next";
import { useRouter } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandShortcut } from "@/components/ui/command";
import { NAVIGATION_ITEMS } from "@/config/navigation";
import { authClient } from "@/lib/auth-client";
type PaletteRoute = {
  label: string;
  href: UrlObject;
  path: string;
  isDynamic: boolean;
  group: "Navigation" | "Pages";
  description?: string;
  icon?: IconSvgElement;
  protected?: boolean;
};
const normalizePath = (path: string) => path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path;
export default function SearchPalette() {
  const $ = _c(20);
  const router = useRouter();
  const {
    data: session
  } = authClient.useSession();
  const isAuthenticated = Boolean(session?.user);
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] !== isAuthenticated) {
    t0 = NAVIGATION_ITEMS.filter(item => !item.protected || isAuthenticated).map(_temp);
    $[0] = isAuthenticated;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const routes = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const onKeyDown = event => {
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
          event.preventDefault();
          setOpen(_temp2);
        }
      };
      window.addEventListener("keydown", onKeyDown);
      return () => window.removeEventListener("keydown", onKeyDown);
    };
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== routes) {
    t3 = routes.reduce(_temp3, {
      Navigation: [],
      Pages: []
    });
    $[4] = routes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const groupedRoutes = t3;
  let t4;
  if ($[6] !== router) {
    t4 = route_0 => {
      if (route_0.isDynamic) {
        return;
      }
      router.push(route_0.path as Route);
      setOpen(false);
    };
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleRouteSelect = t4;
  const hasAnyRoutes = groupedRoutes.Navigation.length > 0;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CommandInput placeholder="Search pages..." />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = hasAnyRoutes ? "No results found." : "No routes available.";
  let t7;
  if ($[9] !== t6) {
    t7 = <CommandEmpty>{t6}</CommandEmpty>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== groupedRoutes.Navigation || $[12] !== handleRouteSelect) {
    t8 = groupedRoutes.Navigation.length > 0 ? <CommandGroup heading="Navigation">{groupedRoutes.Navigation.map(route_1 => <CommandItem key={route_1.path} value={`${route_1.label} ${route_1.path}`} onSelect={() => handleRouteSelect(route_1)}>{route_1.icon ? <HugeiconsIcon icon={route_1.icon} className="h-4 w-4 shrink-0 text-muted-foreground" /> : null}<span className="font-medium text-foreground">{route_1.label}</span><CommandShortcut>{route_1.path}</CommandShortcut></CommandItem>)}</CommandGroup> : null;
    $[11] = groupedRoutes.Navigation;
    $[12] = handleRouteSelect;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <Command shouldFilter={true}>{t5}<CommandList>{t7}{t8}</CommandList></Command>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== open || $[18] !== t9) {
    t10 = <CommandDialog open={open} onOpenChange={setOpen}>{t9}</CommandDialog>;
    $[17] = open;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp3(acc, route) {
  acc[route.group].push(route);
  return acc;
}
function _temp2(prev) {
  return !prev;
}
function _temp(item_0) {
  return {
    label: item_0.label,
    href: item_0.href,
    path: normalizePath(item_0.pathname),
    isDynamic: false,
    group: "Navigation" as const,
    icon: item_0.icon
  };
}